<script setup lang="ts">
import StoreIcon from '#assets/svg/store.svg?component';
</script>

<template>
  <StoreIcon class="w-6 h-6" />
</template>
